<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn class="hidden-sm-and-down py-3"
             @click="openChat()"
             outlined
             color="white"
             rounded
             small
             v-on="on">
        <v-icon left size="23px">
          mdi-face-agent
        </v-icon>
        <span class="hidden-sm-and-down">
          {{ $t('toolbar.support') }}
        </span>
      </v-btn>
    </template>
    <span>{{ $t('toolbar.support') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    openChat () {
      window.keybe.openChat()
    }
  }
}
</script>
